import React from 'react'
import { Slider as CarbonSlider } from 'carbon-components-react'
import cn from 'classnames'

import './index.scss'

const Slider = (props) => {
  const inputSlider = document.getElementById(`${props.id}-input-for-slider`)
  inputSlider?.parentNode?.removeChild(inputSlider)

  const onChangeNumber = (e) => {
    if (props.disabled || props.readOnly) {
      return
    }
    // Do nothing if we have no valid event, target, or value
    if (!e || !('target' in e) || typeof e.target.value !== 'string') {
      return
    }
    props.onChange({ value: e.target.value })
  }

  const onBlur = (e) => {
    if (e.target.value === '') {
      props.onChange({ value: 0 })
    }
    props.invalidText && props.invalid
      ? e.target.setCustomValidity(props.invalidText)
      : e.target.setCustomValidity('')
  }

  return (
    <div className='slider-custom'>
      <CarbonSlider {...props} />
      <input
        type={props.hideTextInput ? 'hidden' : 'number'}
        invalid={props.invalid}
        onBlur={onBlur}
        className={cn('input-number-slider', {
          'input-number-slider-invalid': props.invalid
        })}
        value={props.value}
        onChange={onChangeNumber}
        min={props.min}
        max={props.max}
        onKeyPress={(event) => {
          if (!/[0-9]/.test(event.key) && props.min >= 0) {
            event.preventDefault()
          }
        }}
        onInvalid={(e) => {
          props.invalidText && props.invalid
            ? e.target.setCustomValidity(props.invalidText)
            : e.target.setCustomValidity('')
        }}
      />
    </div>
  )
}

export default Slider
